export default [
    require("./image0.jpg"), require("./image1.jpg"), require("./image2.jpg"), require("./image3.jpg"), require("./image4.jpg"), require("./image5.jpg"), require("./image6.jpg"), require("./image7.jpg"), require("./image8.jpg"), require('./image9.jpg'), require('./image10.jpg'),
]